import {
  WorkspaceMemberStatus,
  type WorkspaceMemberWithUserDto,
} from '@up2stay/up2promo-api-client';

export function memberInviteEmail(
  member: WorkspaceMemberWithUserDto,
): string | null {
  return member.user?.email ?? member.email ?? null;
}

export function memberDisplayName(
  member: WorkspaceMemberWithUserDto,
  unknownUserLabel: string,
): string {
  const user = member.user;
  if (user?.firstName && user?.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  if (user?.firstName) {
    return user.firstName;
  }
  const email = memberInviteEmail(member);
  if (email) {
    return email;
  }
  if (user?.username) {
    return user.username;
  }
  return unknownUserLabel;
}

export function memberInitials(member: WorkspaceMemberWithUserDto): string {
  const user = member.user;
  if (user?.firstName && user?.lastName) {
    return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase();
  }
  if (user?.firstName) {
    return (user.firstName[0] ?? '?').toUpperCase();
  }
  const email = memberInviteEmail(member);
  if (email) {
    return (email[0] ?? '?').toUpperCase();
  }
  if (user?.username) {
    return (user.username[0] ?? '?').toUpperCase();
  }
  return '?';
}

export function isPendingInvitation(
  member: WorkspaceMemberWithUserDto,
): boolean {
  return member.status === WorkspaceMemberStatus.PENDING;
}
